import {observer} from 'mobx-react'
import UI from '../stores/UI'
import CONTENT from '../stores/Content'
import DesktopGallery from '../components/DesktopGallery'
import MobileGallery from '../components/MobileGallery'

class ProjectView extends React.Component {

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    CONTENT.fetchProjectBySlug(this.props.match.params.slug)
    UI.toggleProjectViewStatus(true)
    this.freeze()
    window.addEventListener('orientationchange', this.handleRotate)
  }

  componentDidMount() {
    if (!UI.homepageReady) {
      UI.toggleIntroPadding(false)
      UI.listenToTransform(false)
    }
  }

  componentWillUnmount() {
    UI.toggleProjectViewStatus(false)
    this.unfreeze()
    window.removeEventListener('orientationchange', this.handleRotate, false)
  }

  handleRotate = e => {
    document.body.scrollTop = window.pageYOffset || document.documentElement.scrollTop
  }

  freeze() {

    // Get current window position
    var top = window.pageYOffset || document.documentElement.scrollTop;

    // Set overflow hidden on relevant elements
    // ---
    // <html>
    document.documentElement.style.overflow = 'hidden';
    // <body>
    document.body.style.overflow = 'hidden';
    
    document.body.scrollTop = UI.homepageReady ? top : window.innerHeight
  }

  unfreeze() {
    // This was in the didmount of other pages...
    document.body.style.overflow= ''
    document.documentElement.style.overflow = ''

    // document.body.scrollTop = 1000
  }

  render() {
    return UI.isTouch ? <MobileGallery {...this.props} /> : <DesktopGallery {...this.props} />
  }
}

export default observer(ProjectView)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/ProjectView.js